// This directive should use as parent for input tag, Still some enhancement to be do in code.
(function () {
  angular.module('kareo.ui.shared.directives.billing-workflow.list-scroll', [])
      .directive('listScroll',
        () => {
          return {
            restrict: 'A',
            link: listScrollLink
          };
        });
  function listScrollLink(scope, element) {
    var KEYBOARD__EVENT_DOWN_ARROW = 40;
    var KEYBOARD__EVENT_UP_ARROW = 38;
    var selectedItem = -1;
    var inputElemet = element.find('input');
    inputElemet.bind('keydown', handleListScroll);
    // Set list scroll top.
    var setScrollOffset = function (listEle, parentContainer, isPreviousFunction) {
      if (!isPreviousFunction) { // for key down
        parentContainer.scrollTop = listEle.offsetTop - parentContainer.offsetHeight;
      } else {
        parentContainer.scrollTop = (listEle.offsetTop < listEle.offsetHeight) ? 0 : listEle.offsetTop;
      }
    };
    var adjustScroll = function (event, isPreviousFunction) {
      var directiveRoot = event.target.parentElement;
      var children = directiveRoot.getElementsByClassName('selected');
      if (children.length > 0) {
        var tempElement = children[0].parentElement;
        var child = isPreviousFunction ? tempElement.previousElementSibling :
            tempElement.nextElementSibling;
        if (!child) {
          return;
        }
        var parent;
        if (directiveRoot.getElementsByClassName('list-scroll-parent').length) {
          parent = directiveRoot.getElementsByClassName('list-scroll-parent')[0];
        } else {
          parent = directiveRoot.getElementsByClassName('type-ahead-results')[0];
        }
        setScrollOffset(child, parent, isPreviousFunction);
      }
    };

    function keyDownHandler(scrollElementList) {
      if (scrollElementList.length) {
        var max = scrollElementList.length - 1;
        if (selectedItem >= max) {
          selectedItem = max;
        } else {
          selectedItem += 1;
        }
      }
      angular.element(scrollElementList[selectedItem - 1]).find('a').removeClass('selected');
      angular.element(scrollElementList[selectedItem]).find('a').addClass('selected');
      adjustScroll(event, false);
    }

    function keyUpHandler(scrollElementList) {
      if (scrollElementList.length) {
        if (selectedItem > 0) {
          selectedItem -= 1;
        } else {
          selectedItem = 0;
        }
        angular.element(scrollElementList[selectedItem + 1]).find('a').removeClass('selected');
        angular.element(scrollElementList[selectedItem]).find('a').addClass('selected');
        adjustScroll(event, true);
      }
    }
    function handleListScroll(event) {
      var keyCode = event.keyCode;
      var scrollElementList = element[0].getElementsByClassName('scroll-items');
      if (!(keyCode === KEYBOARD__EVENT_DOWN_ARROW || keyCode === KEYBOARD__EVENT_UP_ARROW)) {
        selectedItem = -1;
        return;
      }

      if (scrollElementList[0] && scrollElementList[0].querySelector('.selected')) {
        selectedItem = 0;
      }

      if (keyCode === KEYBOARD__EVENT_DOWN_ARROW) {
        keyDownHandler(scrollElementList);
      }
      if (keyCode === KEYBOARD__EVENT_UP_ARROW) {
        keyUpHandler(scrollElementList);
      }
    }
  }
})();
